import React from "react";
import AddUpdateUI from "./AddUpdateUI.jsx";

const AddUpdateCategory = ({ formik }) => {
  return <AddUpdateUI formik={formik} />;
};

export default AddUpdateCategory;
